import { useMemo } from 'react';
import useTrackingCore from './core';

export default function usePaymentTracking() {
  const { trackEventWithCoupon, trackEventWithoutProperties } =
    useTrackingCore();

  const successTrackingFunctions = useMemo(() => {
    return {
      confirmationViewed: ({ type, method, tickets, total, currency }) => {
        trackEventWithCoupon('confirmation_viewed', {
          payment_type: type,
          payment_method: method,
          payment_status: 'success',
          total_tickets: tickets,
          total_price: total,
          currency,
        });
      },
      viewOtherEventsClicked: () => {
        trackEventWithoutProperties('view_other_events_clicked');
      },
      buyAgainClicked: () => {
        trackEventWithoutProperties('buy_again_clicked');
      },
    };
  }, [trackEventWithoutProperties, trackEventWithCoupon]);

  return successTrackingFunctions;
}
